
export const MEMBERS_API_CALL = 'https://geektrust.s3-ap-southeast-1.amazonaws.com/adminui-problem/members.json';